import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const MapsGuard = createFeatureGuard(Feature.Maps);